export default {
  text: {
    primary: "#041735",
    normal: "#FFFFFF",
    secondary: "#858597",
    less: "#B1B1BC",
    highlight: "#328AFF",
  },
};
